export function ToursHeader() {
  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-3xl font-bold">Горящие предложения</h1>
    </div>
  );
}
